/**
 * The support service is not deployed (operator ruling 2026-10-12, answer 4 of
 * KG record 2026-10-12-rob-s-eight-answers-of-2026-10-12-second-set.md), so the
 * operator Support pages say so instead of reporting a failure (operator ruling
 * 2026-10-16).
 *
 * platform.aaim.com sends /api/* to this SPA's nginx. Its /api/v1/support/
 * block's upstream, SUPPORT_URL, is empty, so the block answers 404
 * {"error":"route_not_found","source":"nginx-dead-default"} with no upstream
 * call; the predicate requires both members. A 503 means the same. A 404
 * the support service itself sends carries the spec's ErrorBody
 * (support-platform.openapi.yaml) and keeps its meaning, such as "Case not
 * found". Any other failure keeps the page's own error.
 */

import { Alert } from '@aaimplatform/ui';

export const SUPPORT_SERVICE_MISSING_TITLE = 'The support service is not available';

export class SupportServiceMissingError extends Error {
  constructor() {
    super(SUPPORT_SERVICE_MISSING_TITLE);
    this.name = 'SupportServiceMissingError';
  }
}

export function isSupportServiceMissing(response: { status: number } | undefined, error: unknown): boolean {
  const status = response?.status;
  if (status === 503) return true;
  if (status !== 404 || typeof error !== 'object' || error === null) return false;
  const body = error as { error?: unknown; source?: unknown };
  return body.error === 'route_not_found' && body.source === 'nginx-dead-default';
}

/** The error to throw for a failed support call: the missing-service error, or a plain one with `fallback`. */
export function supportFailure(response: { status: number } | undefined, error: unknown, fallback: string): Error {
  return isSupportServiceMissing(response, error) ? new SupportServiceMissingError() : new Error(fallback);
}

export function SupportServiceNotice() {
  return (
    <Alert type="warning" title={SUPPORT_SERVICE_MISSING_TITLE}>
      The support service did not answer this page&apos;s requests, so support cases cannot be read or worked from
      this console.
    </Alert>
  );
}
